import { render } from "./fixedForm.vue?vue&type=template&id=d0270150&scoped=true"
import script from "./fixedForm.vue?vue&type=script&lang=js"
export * from "./fixedForm.vue?vue&type=script&lang=js"

import "./fixedForm.vue?vue&type=style&index=0&id=d0270150&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0270150"]])

export default __exports__